import { useState, useRef, useEffect } from 'react';
import useApi from "./useApi";

function useMaterial () {
    const [materialsByProjectType, setMaterialsByProjectType] = useState(null);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const materialsByProjectTypeApi = useApi('material/GetMaterialsByProjectType');
    const materialsByProjectTypeLoad = useRef(true);

    useEffect(() => {
        if (materialsByProjectTypeLoad.current) {
            materialsByProjectTypeLoad.current = false;
            return;
        }

        setMaterialsByProjectType(materialsByProjectTypeApi.data);
        setLoading(materialsByProjectTypeApi.loading);
        setError(materialsByProjectTypeApi.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [materialsByProjectTypeApi]);

    const getByProjectType = async (projectTypeId, includePrices) => {
        includePrices = Boolean(includePrices);
        setLoading(true);
        materialsByProjectTypeApi.get({
            projectTypeId: projectTypeId,
            includePrices: includePrices
        });
    }

    return {
        materialsByProjectType,
        error,
        loading,
        getByProjectType
    };
}

export default useMaterial;